import { z } from 'zod'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

import { category as BudgetCategory } from '@/__generated__/requests'

export const editTransactionFormSchema = z.object({
  category: z.nativeEnum(BudgetCategory, {
    message: FORM_MESSAGES_MAP.REQUIRED,
  }),
  name: z.string().min(1, { message: FORM_MESSAGES_MAP.EMPTY }),
})
